import { render } from "./s404.vue?vue&type=template&id=3cfbc9a3"
const script = {}
script.render = render

export default script